import { action, makeObservable, observable, runInAction } from "mobx";
import { ExpandableKeys, Filter } from "./core";
import nsi from "./nsi";
import dictionaryStore from "./dictionary";

export class DefectFilterFields extends Filter {
  visibleFieldsKeys: ExpandableKeys = new ExpandableKeys();
  tempVisibleFieldsKeys: ExpandableKeys = new ExpandableKeys();

  findKey = 0;

  constructor() {
    super();
    makeObservable(this, {
      tempVisibleFieldsKeys: observable,
      loadDictionaries: action,

      findKey: observable,
      changeFindKey: action,
    });
  }

  loadDictionaries = () => {
    // dictionaryStore.getDictionaryData("ResourceType");
    dictionaryStore.getDictionaryData("District");
    dictionaryStore.getDictionaryData("WorkStatus");
    dictionaryStore.getDictionaryData("RestrictionNature");
    dictionaryStore.getDictionaryData("RepairCategory");
    dictionaryStore.getDictionaryData("IncidentStatus");
    dictionaryStore.getDictionaryData("MkaStatus");
    nsi.getGridTypes();
    nsi.getOrganizations();
  };

  changeFindKey = () => {
    this.findKey += 1;
  };
}

const defectFilterFieldStore = new DefectFilterFields();
export default defectFilterFieldStore;
